import * as io from 'io-ts';
import { DisclosuresAttribute } from './Disclosures';

export const DeliveryMethod = io.union([
  io.literal('SMS'),
  io.literal('EMAIL'),
]);

export type DeliveryMethod = io.TypeOf<typeof DeliveryMethod>;

const UatPayloadPartial = io.type({
  auth: io.type({
    token: io.string,
  }),
});

export const SendCodePayload = io.type({
  email: io.union([io.string, io.undefined, io.null]),
  phone: io.union([io.string, io.undefined, io.null]),
  deliveryMethod: DeliveryMethod,
  disclosures: DisclosuresAttribute,
  uat: io.union([UatPayloadPartial, io.undefined]),
});

export type SendCodePayload = io.TypeOf<typeof SendCodePayload>;

export const CodeResult = io.type({
  referenceID: io.string,
});

export type CodeResult = io.TypeOf<typeof CodeResult>;

export const OTPDeliveryStatusResult = io.type({
  status: io.string,
});

export type OTPDeliveryStatusResult = io.TypeOf<typeof OTPDeliveryStatusResult>;
